import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import {
    Shield,
    Home,
    BarChart,
    Users,
    Car,
    Settings,
    MessageSquare,
    FileText,
    Clock,
    Database,
    LogOut
} from 'lucide-react';

const Sidebar = ({ isOpen, onToggle }) => {
    const location = useLocation();
    const { user, logout } = useAuth();

    // 確定當前頁面的活動狀態
    const isActive = (path) => {
        return location.pathname.startsWith(path);
    };

    // 根據用戶角色過濾菜單項
    const getMenuItems = () => {
        const baseItems = [
            { path: '/dashboard', name: '儀表板', icon: <Home className="w-5 h-5" /> },
            { path: '/orders', name: '訂單管理', icon: <Clock className="w-5 h-5" /> },
            { path: '/drivers', name: '司機管理', icon: <Car className="w-5 h-5" /> },
        ];

        // 只有管理員可以看到的菜單項
        if (user.user_type === 'admin') {
            return [
                ...baseItems,
                { path: '/users', name: '用戶管理', icon: <Users className="w-5 h-5" /> },
                { path: '/fleets', name: '車隊管理', icon: <Database className="w-5 h-5" /> },
                { path: '/dispatchers', name: '調度員管理', icon: <Users className="w-5 h-5" /> },
                { path: '/messages', name: '消息中心', icon: <MessageSquare className="w-5 h-5" /> },
                { path: '/reports', name: '數據報表', icon: <BarChart className="w-5 h-5" /> },
                { path: '/settings', name: '系統設置', icon: <Settings className="w-5 h-5" /> },
                { path: '/logs', name: '操作日誌', icon: <FileText className="w-5 h-5" /> },
            ];
        }

        // 調度員看到的菜單項
        return [
            ...baseItems,
            { path: '/messages', name: '消息中心', icon: <MessageSquare className="w-5 h-5" /> },
            { path: '/reports', name: '數據報表', icon: <BarChart className="w-5 h-5" /> },
        ];
    };

    return (
        <div className={`${isOpen ? 'w-64' : 'w-16'} bg-gray-800 h-full transition-width duration-300 ease-in-out`}>
            <div className="h-full flex flex-col">
                {/* Logo 區域 */}
                <div className="flex items-center justify-center h-16 bg-gray-900">
                    <div className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center">
                        <Shield className="w-5 h-5 text-white" />
                    </div>
                    {isOpen && (
                        <h2 className="ml-2 text-white font-bold">SmartRide 後台</h2>
                    )}
                </div>

                {/* 選單項目 */}
                <nav className="flex-1 py-4 overflow-y-auto">
                    <ul>
                        {getMenuItems().map((item) => (
                            <li key={item.path} className="mb-2 px-3">
                                <NavLink
                                    to={item.path}
                                    className={({ isActive }) =>
                                        `flex items-center p-2 rounded-md transition-colors
                    ${isActive
                                            ? 'bg-blue-500 text-white'
                                            : 'text-gray-400 hover:bg-gray-700 hover:text-white'}`
                                    }
                                >
                                    <div className="flex items-center">
                                        {item.icon}
                                        {isOpen && <span className="ml-3">{item.name}</span>}
                                    </div>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>

                {/* 登出按鈕 */}
                <div className="p-4">
                    <button
                        onClick={logout}
                        className="w-full flex items-center p-2 text-gray-400 hover:bg-gray-700 hover:text-white rounded-md transition-colors"
                    >
                        <LogOut className="w-5 h-5" />
                        {isOpen && <span className="ml-3">登出</span>}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;